const countdownBlocks = document.querySelectorAll('.shipping-countdown-bar-block'); 

countdownBlocks.forEach(block => {
  const messageElement = block.querySelector('.shipping-message');
  const timerElement = block.querySelector('.countdown-timer');

  // Get the data from the block
  const {
    rmMsg,
    evriMsg,
    weekdayMsg,
    weekendMsg,
    rmCutoff,
    evriCutoff,
    countdownColor,
    countdownFontWeight,
    highlightedText, // This is the value to replace {highlighted_text} in the message template
    highlightMsgColor, 
    highlightMsgFontWeight
  } = block.dataset;

  if (!messageElement || !timerElement) {
    console.error('Countdown block is missing a .shipping-message or .countdown-timer element.', block);
    return; 
  }

  // Helper to format time as 03:20:05
  function formatCountdown(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  }

  // Helper to format the cutoff time as "6pm" or "18:00"
  function formatCutoff(date) {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    return `${hours}${minutes === 0 ? '' : ':' + String(minutes).padStart(2, '0')}${ampm}`;
  }

  const updateCountdown = () => {
    const now = new Date();
    const day = now.getDay(); // 0 = Sunday, 6 = Saturday
    const isWeekend = (day === 0 || day === 6);

    let targetTime, message = '', showTimer = true, msgTemplate = '', cutoffTimeString = '';

    if (isWeekend) {
      message = weekendMsg;
      showTimer = false;
    } else {
      // Weekday logic
      // Parse cutoff times
      const [rmHour, rmMinute, rmSecond] = rmCutoff.split(':').map(Number);
      const rmCutoffDate = new Date(now);
      rmCutoffDate.setHours(rmHour, rmMinute, rmSecond, 0);

      const [evriHour, evriMinute, evriSecond] = evriCutoff.split(':').map(Number);
      const evriCutoffDate = new Date(now);
      evriCutoffDate.setHours(evriHour, evriMinute, evriSecond, 0);

      if (now < rmCutoffDate) {
        targetTime = rmCutoffDate;
        msgTemplate = rmMsg;
        cutoffTimeString = formatCutoff(rmCutoffDate);

      } else if (now < evriCutoffDate) {
        targetTime = evriCutoffDate;
        msgTemplate = evriMsg;
        cutoffTimeString = formatCutoff(evriCutoffDate);
    
      } else {
        // After all cutoffs for the day
        message = weekdayMsg;
        showTimer = false;
      }
    }

    // Replace {countdown} and {cutoff}  in message template
    if (showTimer && targetTime && msgTemplate) {
      const totalSeconds = Math.floor((targetTime - now) / 1000);
      if (totalSeconds > 0) {
        // Replace placeholders
        const countdownStr = formatCountdown(totalSeconds);

        // Replace {countdown} and {highlighted_text} with a styled span
        let messageWithCountdown = msgTemplate
          .replace(
            '{countdown}',
            `<span style="color: ${countdownColor}; font-weight: ${countdownFontWeight};">${countdownStr}</span>`
          )
          .replace(
            '{highlighted_text}',
            `<span style="color: ${highlightMsgColor}; font-weight: ${highlightMsgFontWeight};">${highlightedText}</span>`
          );

        message = messageWithCountdown;

        // Insert the message as HTML so the span is rendered
        messageElement.innerHTML = message;
        timerElement.style.display = 'none'; // Timer is now inside the message
        return;
      } else {
        // If time has just passed
        message = weekdayMsg;
        showTimer = false;
      }
    }

    // Update the message text (no countdown)
    messageElement.textContent = message;
    timerElement.style.display = 'none'; // Always hide the old timer
  };

  updateCountdown();
  setInterval(updateCountdown, 1000);
});
